module.exports = __webpack_public_path__ + "static/media/Akia W.029cf23b.jpeg";